import { Link } from "react-router-dom";
import { AddToCart, AddToWishList, BuyNow } from "../../../../../constants";
import { routes } from "../../../../../routers/routes";

// This component provides buttons for adding items to the cart, checking out, and adding items to the wishlist.
const Buttons = () => {

  return (
    <div className="m-t-15 btn-showcase">
      <Link className="btn btn-primary" to={routes.ECommerce.Cart}>
        <i className="fa fa-shopping-basket me-1"></i>
        {AddToCart}
      </Link>
      <Link className="btn btn-success" to={routes.ECommerce.Checkout}>
        <i className="fa fa-shopping-cart me-1"></i>
        {BuyNow}
      </Link>
      <Link className="btn btn-secondary" to={routes.ECommerce.Wishlist}>
        <i className="fa fa-heart me-1"></i>
        {AddToWishList}
      </Link>
    </div>
  );
};
export default Buttons;